import React, { createContext, useContext, useMemo } from 'react';

export type ListVariants = 'funds' | 'aids';

export type VariantContextType = ListVariants | undefined;

export const variantToPath: Record<ListVariants, string> = {
  aids: 'pomucky',
  funds: 'fondy',
};

const VariantContext = createContext<VariantContextType>(undefined);

export const VariantContextProvider: React.FC<{
  variant: ListVariants;
}> = ({ children, variant }) => {
  const ctx = useMemo(() => variant, [variant]);
  return (
    <VariantContext.Provider value={ctx}>{children}</VariantContext.Provider>
  );
};
export const useVariantContext = () => useContext(VariantContext);
